import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { CONTACT_INFO } from '@awo-care/shared-core';
import { BackToHomeComponent } from '../../../back-to-home/back-to-home.component';

@Component({
  selector: 'awo-care-impressum',
  standalone: true,
  imports: [MatDividerModule, BackToHomeComponent],
  template: `
    <div class="impressum-container">
      <h1 i18n="@@footer.impressum.title">Impressum</h1>

      <div class="content">
        <h2 i18n="@@footer.impressum.section1">Angaben gemäß § 5 TMG</h2>

        <h2 i18n="@@footer.impressum.section2">
          Betreiber und inhaltlich Verantwortlicher
        </h2>
        <p>{{ contact.ORGANIZATION_NAME }}</p>
        <p>{{ contact.ADDRESS_STREET }}</p>
        <p>{{ contact.ADDRESS_POSTAL_CODE }} {{ contact.ADDRESS_CITY }}</p>
        <p>
          <span i18n="@@footer.impressum.phone">Telefon</span>:
          {{ contact.PHONE_MAIN }}
        </p>
        <p>
          <span i18n="@@footer.impressum.email">E-Mail</span>:
          <a [href]="'mailto:' + contact.EMAIL_MAIN">{{
            contact.EMAIL_MAIN
          }}</a>
        </p>
        <p>
          <span i18n="@@footer.impressum.websitePrefix">Internet</span>:
          <a [href]="contact.WEBSITE_URL" target="_blank">{{
            contact.WEBSITE_DISPLAY
          }}</a>
        </p>

        <mat-divider></mat-divider>

        <h2 i18n="@@footer.impressum.section3">Vertreten durch</h2>
        <p>
          <span i18n="@@footer.impressum.ceoLabel">Geschäftsführer</span>:
          {{ contact.CEO_NAME }}
        </p>
        <p>
          <span i18n="@@footer.impressum.boardLabel"
            >Aufsichtsratsvorsitzender</span
          >:
          {{ contact.BOARD_CHAIR_TITLE }}
        </p>

        <mat-divider></mat-divider>

        <h2 i18n="@@footer.impressum.section4">Registereintrag</h2>
        <p i18n="@@footer.impressum.registerEntry">
          Eingetragen im Handelsregister
        </p>
        <p>
          <span i18n="@@footer.impressum.courtLabel">Registergericht</span>:
          {{ contact.COURT_NAME }}
        </p>
        <p>
          <span i18n="@@footer.impressum.registerNumberLabel"
            >Registernummer </span
          >:
          {{ contact.REGISTER_NUMBER }}
        </p>

        <mat-divider></mat-divider>

        <h2 i18n="@@footer.impressum.section5">Steuernummern</h2>

        <p>
          <span i18n="@@footer.impressum.taxNumberLabel">St.-Nr.</span>:
          {{ contact.TAX_NUMBER }}
        </p>
        <p>{{ contact.TAX_ID_FORMATTED }}</p>

        <mat-divider></mat-divider>

        <h2 i18n="@@footer.impressum.bankDetailsTitle">Bankverbindung</h2>

        <p>{{ contact.BANK_NAME }}</p>
        <p>IBAN: {{ contact.BANK_IBAN }}</p>
        <p>BIC: {{ contact.BANK_BIC }}</p>

        <awo-care-back-to-home />
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [
    `
      .impressum-container {
        max-width: 800px;
        margin: 0 auto;
        padding: 2rem;
      }
    `,
  ],
})
export class ImpressumComponent {
  protected readonly contact = CONTACT_INFO;
}
